import ListingSearchList from '@component/card/listings/searchList'
import { SkeletonCard } from '@component/card/listings/standard'
import { each, get, map, range, size } from 'lodash-es'
// import NextPageButton from '../nextPage'
import GoogleAdvert from '@component/google/advert'
import classNames from 'classnames'
import { Fragment } from 'react'
import ShowCaseContent from '../showCase/content'

export default function SearchListContent({
  data,
  totals,
  pageIndex,
  state,
  params,
  cardProps
}) {

  const { showMap, searchParams } = state
  const isPageAlt = get(searchParams, 'page') === 'alt'
  // 区分推荐房源和普通房源
  const showCaseData = []
  const otherData = []
  each(data, item => {
    if (item.isShowcase && typeof params.order === 'undefined') {
      showCaseData.push(item)
    } else {
      otherData.push(item)
    }
  })

  return (
    <>
      {
        size(showCaseData) > 0 && (
          <ShowCaseContent data={showCaseData} showMap={showMap} {...cardProps} />
        )
      }
      <section className={getContainerClassName(showMap)}>
        {
          map(otherData, (item, idx) => (
            <Fragment key={item.id}>
              {
                [8, 17, 22, 31].includes(idx) && (
                  <GoogleAdvert showTitle={false} showSub={false} adsize={[[300, 250], ["fluid"]]} adunit='rectangle' id={`ad-native-${idx}`} key={`ad-listings-${idx}`}></GoogleAdvert>
                )
              }
              <ListingSearchList
                data={item}
                key={item.id}
                {...cardProps}
                hoverTranslate
                nativeLink={get(state, 'showMap')}
                isPageAlt={isPageAlt}
              />
            </Fragment>
          ))
        }
        {/* <NextPageButton totals={totals} pageIndex={pageIndex} state={state}></NextPageButton> */}
      </section>
    </>
  )
}

export function SkeletonSearchList({
  showMap = false,
  listLen
}) {

  const len = showMap ? Math.max(listLen + 40, 8) : 8
  return (
    <div className={classNames('skeleton-wrap', getContainerClassName(showMap))}>
      {
        map(range(0, len), item => (
          <SkeletonCard key={item}></SkeletonCard>
        ))
      }
    </div>
  )
}

function getContainerClassName(showMap) {
  return classNames('grid grid-cols-1 gap-16', showMap ? 'xl:grid-cols-2' : 'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4')
}